// src/locales/en/subscription.js
export const subscription = {
  // Page title and navigation
  pageTitle: 'Subscription Plans',
  mySubscription: 'My Subscription',
  allPlans: 'All Plans',
  
  // Plan names
  starter: 'Starter',
  growth: 'Growth',
  pro: 'Pro',
  ultimate: 'Ultimate',
  
  // Status labels
  currentPlan: 'Current Plan',
  recommended: 'Recommended',
  mostPopular: 'Most Popular',
  
  // Actions
  subscribe: 'Subscribe',
  upgrade: 'Upgrade',
  downgrade: 'Downgrade',
  cancel: 'Cancel',
  reactivate: 'Reactivate',
  contactSales: 'Contact Sales',
  
  // Billing
  billingCycle: 'Billing Cycle',
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  yearly: 'Yearly',
  perMonth: '/month',
  billed: 'Billed',
  billedMonthly: 'Billed Monthly',
  billedQuarterly: 'Billed Quarterly',
  billedYearly: 'Billed Yearly',
  
  // Features
  features: 'Features',
  productsLimit: '{{count}} Products',
  productsUnlimited: 'Unlimited Products',
  shopsLimit: '{{count}} Shops',
  shopsUnlimited: 'Unlimited Shops',
  ordersLimit: '{{count}} Orders/month',
  ordersUnlimited: 'Unlimited Orders',
  usersLimit: '{{count}} Users',
  usersUnlimited: 'Unlimited Users',
  warehousesLimit: '{{count}} Warehouses',
  warehousesUnlimited: 'Unlimited Warehouses',
  
  // Usage
  usage: 'Usage',
  usageStatistics: 'Usage Statistics',
  currentUsage: 'Current Usage',
  products: 'Products',
  shops: 'Shops',
  orders: 'Orders',
  users: 'Users',
  warehouses: 'Warehouses',
  unlimited: 'Unlimited',
  used: 'Used',
  remaining: 'Remaining',
  
  // Modals
  confirmSubscription: 'Confirm Subscription',
  confirmUpgrade: 'Confirm Upgrade',
  confirmDowngrade: 'Confirm Downgrade',
  confirmCancellation: 'Confirm Cancellation',
  
  // Modal messages
  subscribeMessage: 'Are you sure you want to subscribe to the {{planName}} plan?',
  upgradeMessage: 'Are you sure you want to upgrade to the {{planName}} plan?',
  downgradeMessage: 'Are you sure you want to downgrade to the {{planName}} plan? This will take effect at the end of your current billing cycle.',
  cancelMessage: 'Are you sure you want to cancel your subscription? You will lose access to premium features.',
  downgradeWarning: 'Warning: Downgrading may affect your current usage. Please ensure your usage is within the new plan limits.',
  usageExceedsLimit: 'Your current usage exceeds the limits of this plan. Please reduce your usage before downgrading.',
  
  // Success messages
  subscribeSuccess: 'Successfully subscribed to {{planName}} plan',
  upgradeSuccess: 'Successfully upgraded to {{planName}} plan',
  downgradeSuccess: 'Downgrade scheduled for next billing cycle',
  cancelSuccess: 'Subscription cancelled successfully',
  reactivateSuccess: 'Subscription reactivated successfully',
  
  // Error messages
  subscribeFailed: 'Failed to subscribe to plan',
  upgradeFailed: 'Failed to upgrade plan',
  downgradeFailed: 'Failed to downgrade plan',
  cancelFailed: 'Failed to cancel subscription',
  reactivateFailed: 'Failed to reactivate subscription',
  loadPlansFailed: 'Failed to load subscription plans',
  loadSubscriptionFailed: 'Failed to load subscription details',
  loadUsageFailed: 'Failed to load usage statistics',
  
  // Plan details
  planDetails: 'Plan Details',
  planPrice: 'Price',
  planFeatures: 'Features',
  free: 'Free',
  
  // Subscription status
  active: 'Active',
  trial: 'Trial',
  expired: 'Expired',
  cancelled: 'Cancelled',
  suspended: 'Suspended',
  trialEndsIn: 'Trial ends in {{days}} days',
  nextBillingDate: 'Next billing date',
  
  // Loading states
  loading: 'Loading...',
  loadingPlans: 'Loading plans...',
  processing: 'Processing...',
  
  // Empty states
  noSubscription: 'No active subscription',
  chooseAPlan: 'Choose a plan to get started',
  
  // Tooltips
  currentPlanTooltip: 'This is your current plan',
  upgradeTooltip: 'Upgrade to access more features',
  downgradeTooltip: 'Downgrade to a lower plan',
  cancelTooltip: 'Cancel your subscription',
  
  // Others
  compare: 'Compare Plans',
  viewDetails: 'View Details',
  getStarted: 'Get Started',
  selectPlan: 'Select Plan',
  changePlan: 'Change Plan',
  manageSubscription: 'Manage Subscription',
  planName: "Plan Name",
  startDate: "Start Date",
  
  // Cancellation reasons
  cancellationReason: 'Reason for cancellation (optional)',
  tooExpensive: 'Too expensive',
  missingFeatures: 'Missing features',
  notUsingEnough: 'Not using enough',
  switchingToCompetitor: 'Switching to competitor',
  other: 'Other',

  // My Business Page
  myBusiness: 'My Business',
  manageBusinessSubscription: 'Manage your business and subscription',
  businessDetails: 'Business Details',
  overview: 'Overview',

  // Business Details
  businessName: 'Business Name',
  currency: 'Currency',
  timezone: 'Timezone',
  memberSince: 'Member Since',
  noBusinessFound: 'No business information found',

  // Current Subscription - Detailed View
  currentSubscription: 'Current Subscription',
  cancelledOn: 'Cancelled on',
  perMonth: '/month',
  perQuarterly: '/quarter',
  perYearly: '/year',
  days: 'days',
  confirmCancellation: 'Confirm Cancellation',
  confirmCancel: 'Confirm Cancellation',

  // Usage Resources
  products: 'Products',
  shops: 'Shops',
  ecomOrders: 'Orders',
  users: 'Users',
  warehouses: 'Warehouses',
  perMonthly: 'per Month',
  perDaily: 'per Day',
  perTotal: 'Total',
  remaining: 'remaining',

  // Payment History
  paymentHistory: 'Payment History',
  nextInvoice: 'Next Invoice',
  paymentDate: 'Payment Date',
  amount: 'Amount',
  paymentMethod: 'Payment Method',
  transactionId: 'Transaction ID',
  invoice: 'Invoice',
  lineItems: 'Line Items',
  subtotal: 'Subtotal',
  tax: 'Tax',
  total: 'Total',
  paid: 'Paid',
  pending: 'Pending',
  failed: 'Failed',
  refunded: 'Refunded',
  noPaymentsYet: 'No payments yet',
  noPaymentsDescription: 'Your payment history will appear here once you make a payment',
  loadPaymentsFailed: 'Failed to load payment history',

  // Error messages
  loadSubscriptionFailed: 'Failed to load subscription details',
  loadUsageFailed: 'Failed to load usage statistics',

  // View actions
  viewPlans: 'View Plans',

  // Quota Warnings
  quotaWarningMonthly: 'You\'ve used {{used}} of {{limit}} {{resource}} this month',
  quotaWarningDaily: 'You\'ve used {{used}} of {{limit}} {{resource}} today',
  quotaWarningTotal: 'You\'ve used {{used}} of {{limit}} {{resource}}',
  quotaRemaining: '{{remaining}} remaining',
  quotaLimitReached: 'Limit reached',
  upgradeNow: 'Upgrade Now',
  unlimitedResource: 'Unlimited {{resource}}',
  quotaExceeded: 'You have exceeded your {{resource}} quota. Please upgrade your plan to continue.',
  quotaCheckFailed: 'Failed to check quota limits',

  // Subscription Status Messages
  subscriptionExpired: 'Your subscription has expired',
  subscriptionExpiredMessage: 'Your subscription has expired. Please renew to continue using premium features.',
  subscriptionCancelled: 'Your subscription was cancelled',
  subscriptionCancelledMessage: 'Your subscription was cancelled. Renew now to regain access to premium features.',
  subscriptionSuspended: 'Your subscription is suspended',
  subscriptionSuspendedMessage: 'Your subscription is suspended. Please contact support or renew your subscription.',
  subscriptionExpiringSoon: 'Your subscription expires in {{days}} days',
  daysRemaining: '{{count}} day remaining',
  daysRemaining_plural: '{{count}} days remaining',
  renewNow: 'Renew Now',
  renewSubscription: 'Renew Subscription',
  renewToAccessFeatures: 'Renew your subscription to access premium features',
  expiredOn: 'Expired on',
  previousPlan: 'Previous Plan',
  contactAdminToRenew: 'Please contact your account administrator to renew the subscription.',
  confirmRenewal: 'Confirm Renewal',
  renewYourSubscription: 'Renew your subscription',
  renewThisPlan: 'Renew This Plan',
  subscriptionHasExpired: 'Your subscription has expired',
  renewBeforeExpiration: 'Renew before your subscription expires to continue using all features',

  //theme
  theme: 'Theme',
  currentTheme: 'Current Theme',
  searchThemes: 'Search themes...',
  allModes: 'All Modes',
  lightOnly: 'Light Only',
  darkOnly: 'Dark Only',
  allColors: 'All Colors',
  light: 'Light',
  dark: 'Dark',
  current: 'Current',
  primaryColor: 'Primary Color',
  secondaryColor: 'Secondary Color',
  confirmThemeChange: 'Confirm Theme Change',
  themeChangeConfirmation: 'Are you sure you want to change your business theme? This will apply to all users.',
  from: 'From',
  to: 'To',
  themeUpdatedSuccess: 'Theme changed to {{theme}} successfully!',
  themeUpdateFailed: 'Failed to update theme. Please try again.',
  themeUpdateError: 'An error occurred while updating theme.',
  themeAlreadySelected: 'This theme is already selected.',
  themePermissionRequired: 'You need manage_subscription permission to change themes.',
  noThemesFound: 'No themes found matching your filters.',
  unsavedThemeChanges: "You have unsaved theme changes. Are you sure you want to leave?",
  discardChanges: "Discard Changes",
  stayOnPage: "Stay on Page",

  // Contact Sales
  contactSales: 'Contact Sales',
  enterprise: 'Enterprise',
  customPricing: 'Custom Pricing',
  contactForPricing: 'Contact us for pricing',
  contactSalesMessage: 'Our enterprise plan offers custom pricing tailored to your business needs. Contact our sales team to discuss your requirements.',
  includedFeatures: 'Included Features',
  email: 'Email',
  phone: 'Phone',
  whatsapp: 'WhatsApp',
  
  // Custom Pricing
  customRate: 'Custom Rate',
  specialPricing: 'Special Pricing',
  originalPrice: 'Original Price',
  yourPrice: 'Your Price',
  customDiscount: 'Custom Discount',

  payment: {
    // Success Page
    successTitle: 'Payment Successful!',
    successMessage: 'Your payment has been processed successfully and your subscription is now active.',
    orderId: 'Order ID',
    subscriptionDetails: 'Subscription Details',
    accessGranted: 'You now have access to:',
    goToDashboard: 'Go to Dashboard',
    viewSubscription: 'View Subscription',
    confirmationEmail: 'A confirmation email has been sent to your registered email address.',
    noSubscriptionFound: 'Unable to load subscription details. Please refresh the page.',

    // Pending Page
    pendingTitle: 'Payment Under Review',
    pendingMessage: 'Thank you for submitting your payment proof. Our team is reviewing your payment.',
    paymentDetails: 'Payment Details',
    paymentProof: 'Payment Proof',
    viewProof: 'View Proof',
    approvalProcess: 'Approval Process',
    estimatedApprovalTime: 'Estimated Approval Time',
    approvalTimeRange: '24-48 business hours',
    whatHappensNext: 'What happens next?',
    
    // Timeline Steps
    step1Title: 'Payment Proof Submitted',
    step1Description: 'Your payment proof has been successfully uploaded and submitted.',
    step2Title: 'Under Review',
    step2Description: 'Our team is currently reviewing your payment proof and verifying the transaction.',
    step3Title: 'Subscription Activation',
    step3Description: 'Once approved, your subscription will be automatically activated.',
    
    // Next Steps
    nextStep1: 'Our team will review your payment proof within 24-48 business hours',
    nextStep2: 'You will receive an email notification once the payment is approved',
    nextStep3: 'Your subscription will be activated immediately after approval',
    
    backToDashboard: 'Back to Dashboard',
    notificationEmail: 'You will receive an email notification once your payment is reviewed.',

    // Payment methods
    selectPaymentMethod: 'Select Payment Method',
    choosePreferredMethod: 'Choose your preferred payment method to complete the subscription',
    bankTransfer: 'Bank Transfer',
    cardPayment: 'Card Payment',
    bankTransferDesc: 'Transfer to our bank account and upload proof',
    cardPaymentDesc: 'Pay securely with your credit or debit card',
    popular: 'Popular',
    
    // Bank transfer
    bankDetails: 'Bank Account Details',
    accountHolder: 'Account Holder Name',
    bankName: 'Bank Name',
    branchName: 'Branch Name',
    branchCode: 'Branch Code',
    accountNumber: 'Account Number',
    copyAccountNumber: 'Copy Account Number',
    accountNumberCopied: 'Account number copied to clipboard',
    copyFailed: 'Failed to copy account number',
    totalAmount: 'Total Amount',
    bankTransferInstructions: 'Please transfer the exact amount to the bank account below and upload proof of payment. Your subscription will be activated after admin approval (usually within 24-48 hours).',
    
    // File upload
    uploadProof: 'Upload Payment Proof',
    uploadProofDescription: 'Upload a clear image or PDF of your bank transfer receipt',
    dragDropOrClick: 'Drag & drop file here, or click to select',
    dropFileHere: 'Drop file here...',
    supportedFormats: 'Supported formats: PNG, JPG, JPEG, PDF (Max 5MB)',
    fileRequired: 'Please upload payment proof',
    invalidFileType: 'Invalid file type. Please upload PNG, JPG, JPEG, or PDF',
    fileTooLarge: 'File size must be less than 5MB',
    submittingProof: 'Submitting...',
    submitProof: 'Submit Payment Proof',
    
    // Card payment
    paymentSummary: 'Payment Summary',
    customerDetails: 'Customer Details',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    payNow: 'Pay Now',
    payWithCard: 'Pay with Card',
    securePayment: 'Secure payment powered by PayHere',
    processingPayment: 'Processing payment...',
    completed: 'Completed',
    termsNotice: 'By proceeding with the payment, you agree to our terms of service and refund policy.',
    
    // Status messages
    paymentPending: 'Payment Pending Approval',
    paymentPendingMessage: 'Your payment proof has been submitted successfully and is awaiting admin approval. This usually takes 24-48 hours. You will receive an email notification once your payment is approved.',
    paymentSuccess: 'Payment Successful!',
    paymentSuccessMessage: 'Your payment was processed successfully. Your subscription has been activated.',
    paymentFailed: 'Payment Failed',
    paymentFailedMessage: 'We could not process your payment. Please try again or contact support if the problem persists.',
    paymentDismissed: 'Payment was cancelled. You can try again when ready.',
    
    // PayHere errors
    payhereNotLoaded: 'Payment gateway not loaded. Please refresh the page and try again.',
    invalidPaymentParams: 'Invalid payment parameters. Please try again.',
    paymentInitFailed: 'Failed to initialize payment. Please try again.',
    
    // Admin
    pendingPayments: 'Pending Payments',
    viewProof: 'View Payment Proof',
    approvePayment: 'Approve Payment',
    rejectPayment: 'Reject Payment',
    rejectionReason: 'Rejection Reason',
    paymentApproved: 'Payment approved successfully',
    paymentRejected: 'Payment rejected',
    submittedOn: 'Submitted on',
    submittedBy: 'Submitted by',

    step: 'Step',
    of: 'of',
    loadingBankDetails: 'Loading bank account details...',
    initializingPayment: 'Initializing payment gateway...',
    paymentDetailsLoadFailed: 'Failed to load payment details. Please try again.',
  }
};